import translations from './translations'

translations.add('pt', {
    description: 'Ocorreu um erro. Verifique os dados ou tente novamente mais tarde.',
    close: 'FECHAR'
})
